<template>
	<div class="canvas-opened">
		<div class="dark-mark"></div>
		<!-- <div class="img-box fadeInDown animated" :style="{backgroundImage:'url('+img+')'}"></div> -->
		<div class="img-box fadeInDown animated">
			
			<div style="display: flex;justify-content: flex-end;">
				<img src="../assets/imgs/icon-close.png" style="width: 2rem;height: 2rem;cursor: pointer;" @click="close()">
			</div>
			<!-- <div class="btn-normal" style="margin-right: 0;" @click="close()">exit</div> -->
			<div style="display: flex;" :style="{marginLeft: '-'+active*100+'%'}" class="transition-02s">
				<div :style="{backgroundImage:'url('+img+')'}" v-for="(img, index) in imglist" :key="index" class="img1"></div>
			</div>
			<div style="display: flex;margin-top: 1rem;width: 100%;justify-content: center;">
				<div style="display: flex;align-items: center;">
					<!-- <div class="btn-normal" @click="pre">previous</div>
					<div class="btn-normal" @click="next">next</div> -->
					<img src="../assets/imgs/banner-left-light.png" style="width: 3rem;height: 3rem;cursor: pointer;" @click="pre">
					<img src="../assets/imgs/banner-right-light.png" style="width: 3rem;height: 3rem;margin-right: 1rem;cursor: pointer;" @click="next">
					<div style="color: #fff;">{{active+1}} / {{imglist.length}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
		export default {
			data() {
				return {
					imglist:[],
					active:0
				}
			},
			props:{
				imgs:Array,
				index:Number
			},
			components: {
			},
			filters: {
	        },
			methods: {
				close() {
					this.$bus.$emit('largeimg', {
						show:false,
						img:''
					})
				},
				pre(){
					if(this.active>0){
						this.active--
					}
				},
				next(){
					if(this.active<this.imglist.length-1){
						this.active++
					}
				}
			},
			mounted() {
				// console.info(this.imgs, this.index)
				this.imglist = this.imgs,
				this.active = this.index
			}
		}
</script>

<style lang="scss" scoped>
	.img-box{
		margin: auto;
		position: fixed;
		top: 5rem; left: 0; bottom: 0; right: 0;
		width:60vw;
		z-index: 997;
		overflow: hidden;
		// display: flex;
		// background-position: center;
		// background-repeat: no-repeat;
		// background-size: contain;
	}
	.img1{
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		min-width: 60vw;min-height: 60vh
	}
	.dark-mark{
		z-index: 996;
		background-color: rgba(0, 0, 0, 0.9);
	}
	@media (max-width:767px) {
		.img-box{
			width: 100vw;
		}
		.img1{
			min-width: 100vw;
		}
	}
</style>